import { elakay_API } from "../../config";
import { consumePostAuthDestination } from "./postAuthRedirect";
import {decryptData}  from '../auth/elakayCryptage'
import { getOrCreateDeviceId, getDeviceName } from "./device";
import { locationQueryParams, notifyLocationInputsChanged } from "../../utils/buyerLocation";
import { authResponseError, authFailureResult, fetchWithAuthTimeout } from "./authErrors";
import { readPresenceVisitorId } from "../../utils/presenceVisitorId";
import { prepareUpload } from "../../utils/uploadPolicy";
import { readUploadResponse, withUploadRetry } from "../../utils/uploadResponse";

let __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["index"]?.[key] || fallback;

// import { creatUserViewed,  addToUserView} from "../auth/apiProduct";

const getClientDeviceInfo = () => {
    if (typeof window === "undefined" || typeof navigator === "undefined") return {};

    const ua = navigator.userAgent || "";
    let device = "Unknown device";
    let model = "Unknown model";
    let browser = "Unknown browser";

    if (/iPhone/.test(ua)) {
        device = "iPhone";
        model = "iPhone";
    } else if (/android/i.test(ua)) {
        const isTablet = !/Mobile/.test(ua);
        device = isTablet ? "Android Tablet" : "Android Phone";
        const modelMatch = ua.match(/; ([^;]+) Build\//);
        model = modelMatch ? modelMatch[1].trim() : "Unknown model";
    } else if (/iPad|Macintosh/.test(ua) && navigator.maxTouchPoints > 0) {
        device = "iPad";
        model = "iPad";
    } else if (/Windows NT/.test(ua)) {
        device = "Windows";
        model = "PC";
    } else if (/Mac OS/.test(ua)) {
        device = "MacOS";
        model = "Mac";
    }

    if (/Edg\//.test(ua)) browser = "Microsoft Edge";
    else if (/OPR|Opera/.test(ua)) browser = "Opera";
    else if (/Chrome/.test(ua) && !/Edg|OPR/.test(ua)) browser = "Google Chrome";
    else if (/Safari/.test(ua) && !/Chrome/.test(ua)) browser = "Safari";
    else if (/Firefox/.test(ua)) browser = "Mozilla Firefox";

    return {
        // Real, persistent identifier -- this is what the server now
        // matches AddressInterface entries against first (exact equality),
        // ahead of the fuzzy device/browser/screen fingerprint below, which
        // remains as a fallback for devices registered before this existed.
        deviceId: getOrCreateDeviceId(),
        deviceName: getDeviceName(),
        device,
        model,
        browser,
        userAgent: ua,
        platform: navigator.platform || "",
        vendor: navigator.vendor || "",
        language: navigator.language || "",
        languages: Array.from(navigator.languages || []),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        touchPoints: navigator.maxTouchPoints || 0,
        online: navigator.onLine,
        screen: {
            width: window.screen?.width,
            height: window.screen?.height,
            availWidth: window.screen?.availWidth,
            availHeight: window.screen?.availHeight,
            colorDepth: window.screen?.colorDepth,
            pixelRatio: window.devicePixelRatio || 1
        }
    };
};

// presenceVisitorId: this browser's existing Live Activity id, so the server
// can attach a sign in / verification to the browser record (Individual
// Activity table, only when Family enabled it). Never a new identifier.
const withClientDeviceInfo = (payload = {}) => ({
    ...payload,
    deviceInfo: payload?.deviceInfo || getClientDeviceInfo(),
    presenceVisitorId: readPresenceVisitorId() || undefined
});


export const signup = async (user,  pubToken )=> {
   try{
   const response = await  fetchWithAuthTimeout(`${elakay_API}/signup`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
             UserPUBToken : `Bearer ${pubToken}`
        },
        body: JSON.stringify(withClientDeviceInfo(user))
    })

    if (!response.ok) {
      throw await authResponseError(response, "signup");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

  } catch (err) {
    return authFailureResult(err, "signup");
  }
};


export const signupUPdateRole = (user,  pubToken )=> {
    return fetch(`${elakay_API}/signupUPdateRole`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
             ...(isAuthenticated()?.token ? { Authorization: `Bearer ${isAuthenticated().token}` } : {}),
             UserPUBToken : `Bearer ${pubToken}`
        },
        body: JSON.stringify(withClientDeviceInfo(user))
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
        });
};
// OU si vous préférez passer par le token dans le body
export const getAtivatorData = async (token) => {
    try {
        const response = await fetch(`${elakay_API}/user/ativator`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                AtivatorToken: `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (err) {
        console.error("Error fetching ativator data:", err);
        return { error: __elakayText("t003", "Failed to load timer data") };
    }
};

export const userActivation = async (user) => {
     try{
   const response = await fetchWithAuthTimeout(`${elakay_API}/user/activation`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(withClientDeviceInfo(user))
    })
  // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      throw await authResponseError(response, "user/activation");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    return authFailureResult(err, "user/activation");
  }
};

export const activatorUserAdding = async (token, key, value, save) => {
     try{
   const response = await fetch(`${elakay_API}/user/activatorUserAdding`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            AuthorizationUserAdding: `Bearer ${token}`
        },
        body: JSON.stringify({[key]: value, save })
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      // authAddingUser.js distinguishes INVALID_TOKEN (401) / TOKEN_EXPIRED
      // (410) / TOKEN_NOT_FOUND (404) — surfaced via err.code below so the
      // page can show a precise status instead of one generic message.
      throw Object.assign(new Error(errorData.error || "Erreur d'identification"), {
        code: errorData.code,
        status: response.status
      });
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue",
      code: err.code,
      status: err.status
    };
  }
};

export const verificationCode = async (user) => {
      try{
   const response = await fetchWithAuthTimeout(`${elakay_API}/user/verificationCode`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(withClientDeviceInfo(user))
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      throw await authResponseError(response, "user/verificationCode");
    }


    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    return authFailureResult(err, "user/verificationCode");
  }
};

export const resendDeviceCode = async (user) => {
      try{
   const response = await fetchWithAuthTimeout(`${elakay_API}/user/reSendDeviceCode`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(withClientDeviceInfo(user))
    })

    if (!response.ok) {
      throw await authResponseError(response, "user/reSendDeviceCode");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    return authFailureResult(err, "user/reSendDeviceCode");
  }
};


// Note: this used to destructure `user.user` for the body (expecting a
// nested `{ token, user: {...} }` shape) while every real caller
// (active.js's resendCode) passes a flat `{ token, numberDigi }` -- meaning
// `user.user` was always undefined and the request body was silently empty.
// Sends the flat object directly now, with the device context merged in
// like every other auth request.
export const reSendCodeSecurity = async (user) => {
    try {
        const response = await fetchWithAuthTimeout(`${elakay_API}/user/reSendCodeSecurity`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                  AuthorizationUserAdding: `Bearer ${user.token}`
            },
            body: JSON.stringify(withClientDeviceInfo(user))
        })
        if (!response.ok) {
            throw await authResponseError(response, "user/reSendCodeSecurity");
        }
        return await response.json();
    } catch (err) {
        return authFailureResult(err, "user/reSendCodeSecurity");
    }
};

export const signin = async (user) => {
     try{
    const response = await  fetchWithAuthTimeout(`${elakay_API}/signin`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(withClientDeviceInfo(user))
    })

      // Vérifie si le statut est une erreur HTTP. The server's stable `code`
      // (INVALID_PASSWORD, USER_NOT_FOUND, ACCOUNT_NOT_ACTIVATED, ...) is
      // returned as `code` for Signin.js to translate; errorCode/suspension
      // still drive the dedicated "account suspended" notice.
    if (!response.ok) {
      throw await authResponseError(response, "signin");
    }


    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    return authFailureResult(err, "signin");
  }
};

// The account's default language (User.language, My Profile) -- sent by the
// server as `l` with a successful sign in -- becomes the UI language only
// when this device has no explicit choice yet. Routes.js stores its automatic
// English default with id 0; a language picked in the header or saved in My
// Profile is stored without that id and is always kept.
export const applyAccountDefaultLanguage = (language) => {
  if (typeof window === "undefined" || !language?.code) return false;
  const stored = getElakayLang();
  const hasExplicitChoice = Boolean(stored?.obj?.code) && stored.id !== 0;
  if (hasExplicitChoice || stored?.obj?.code === language.code) return false;
  SetElakayLang(language, 0);
  return true;
};

export const authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    applyAccountDefaultLanguage(data?.l);
    // Add a timestamp for session start
    data.t = new Date().getTime();
    localStorage.setItem("elakayUser", JSON.stringify(data));
    next();
    // The one document load of a sign in: the whole app (cart, roles,
    // language, role switch) starts again as this account, directly on the
    // page the user was trying to open (?returnUrl= / remembered by a guard),
    // else Home. replace(): the sign-in step never stays in Back history.
    window.location.replace(consumePostAuthDestination("/"));
  }
};

// Stores an authenticated session without changing the current route. Used
// by invitation modals that must resume the exact link after sign-in.
export const authenticateInPlace = (data) => {
  if (typeof window === "undefined") return;
  applyAccountDefaultLanguage(data?.l);
  localStorage.setItem("elakayUser", JSON.stringify({ ...data, t: new Date().getTime() }));
};

// Exporte : aussi utilise par Footer.js pour faire suivre la frequence de
// polling de checkSession au timeout configure dans AnimationSettings.
export const SESSION_TIMEOUT_UNIT_MS = {
  minutes: 60 * 1000,
  hours: 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
  months: 30 * 24 * 60 * 60 * 1000,
};

const readJsonStorage = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};

// Met a jour le timestamp d'activite dans elakayUser sans verifier
// le timeout — a appeler sur toute activite reelle (clic, navigation,
// frappe clavier, scroll). Ne fait rien si l'utilisateur n'est pas connecte.
export const refreshSession = () => {
  if (typeof window === "undefined") return;
  const stored = readJsonStorage("elakayUser");
  if (stored && stored.t) {
    stored.t = new Date().getTime();
    localStorage.setItem("elakayUser", JSON.stringify(stored));
  }
};

// Duree d'avertissement avant l'expiration reelle de la session (3 min).
// Partagee avec Footer.js pour que le widget SessionExpiryWarning et
// checkSession s'accordent sur le meme seuil.
export const SESSION_WARNING_MS = 3 * 60 * 1000;

// `onTimeoutWarning(token, remainingMs)` est optionnel : s'il est fourni,
// checkSession ne deconnecte plus jamais directement — il previent
// l'appelant (le widget flottant du Footer) DES qu'il reste moins de
// SESSION_WARNING_MS avant l'expiration reelle, avec le temps reel restant.
// C'est ensuite le timer du widget SessionExpiryWarning (deja existant dans
// Footer.js) qui decompte et declenche la deconnexion finale — checkSession
// ne rajoute pas de periode de grace supplementaire apres le timeout.
// Sans callback, le comportement historique (suppression immediate au
// timeout) est conserve.
// IMPORTANT : checkSession se contente de VERIFIER le diff — il ne remet
// plus jamais t a jour. Seules les vraies activites (refreshSession) et
// cancelSessionLogout le font, de sorte que le timer demarre reellement
// des que l'utilisateur cesse toute activite sur la plateforme.
export const checkSession = (sessionSettings, onTimeoutWarning) => {
  if (typeof window !== "undefined") {
    if (sessionSettings?.checkSessionEnabled === false) return;

    const stored = readJsonStorage("elakayUser");
    if (stored && stored.t) {
      const now = new Date().getTime();
      const diff = now - stored.t;

      const amount = Number(sessionSettings?.timeoutAmount) || 30;
      const unit = SESSION_TIMEOUT_UNIT_MS[sessionSettings?.timeoutUnit] || SESSION_TIMEOUT_UNIT_MS.minutes;
      const timeout = amount * unit;
      const remaining = timeout - diff;

      if (typeof onTimeoutWarning !== "function") {
        if (diff > timeout) signout(stored.token);
        return;
      }

      if (remaining <= SESSION_WARNING_MS) {
        onTimeoutWarning(stored.token, Math.max(remaining, 0));
      }
      // L'else qui remettait stored.t = now a ete supprime volontairement :
      // le timer doit progresser librement tant qu'il n'y a pas d'activite.
    }
  }
};

// PEPC page elakay product categories
export const savePageName = (pageName) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("PEPC", pageName);
  }
};

export const getPageName = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("PEPC");
  }
  return null;
};

export const SetElakayLang = (name, value) => {
    if (typeof window !== "undefined") {
        localStorage.setItem("elakayLanguage", JSON.stringify({id: value, obj : name}));
        window.dispatchEvent(new CustomEvent("elakay:language-changed", {
            detail: { id: value, obj: name }
        }));
    }
};

export const getElakayLang = () => {
    if (typeof window === "undefined") {
        return false;
    }
    return readJsonStorage("elakayLanguage") || false;
};

export const isAuthenticated = () => {
    if (typeof window === "undefined") {
        return false;
    }
    return readJsonStorage("elakayUser") || false;
};

// export const signout = (token) => {
//     if (typeof window !== "undefined") {
//         return fetch(`${elakay_API}/signout`, {
//             method: "POST",
//             headers: {
//                 Accept: "application/json",
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`
//             }
//         })
//             .then(response => {
//                 localStorage.removeItem("elakayUser");
//             })
//     };

// };

export const signout = (token) => {
  if (typeof window !== "undefined") {
    const revokeCJ = fetch(`${elakay_API}/security/dropshipping/revoke-confirmation`, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    }).catch(() => undefined);
    return revokeCJ.then(() => fetch(`${elakay_API}/signout`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ presenceVisitorId: readPresenceVisitorId() || undefined }),
    }))
      .then(() => {
        localStorage.removeItem("elakayUser");
        clearPersistedSelectedRole(); // Switch Role: never bleed a stale view into the next login on this browser
        window.location.reload();
      })
      .catch((err) => {});
  }
};


export const signOutALL = (token) => {
    return fetch(`${elakay_API}/security/dropshipping/revoke-confirmation`, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    }).catch(() => undefined).then(() => fetch(`${elakay_API}/signoutAll`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ presenceVisitorId: readPresenceVisitorId() || undefined })
    })).then(response => {
        localStorage.removeItem("elakayUser");
        clearPersistedSelectedRole(); // Switch Role: never bleed a stale view into the next login on this browser
        window.location.reload()
        return response.json()
    })
        .catch(err => {
        });
};


// Concurrent reads of the same session share one request: the app shell and
// the page both ask at load (and React StrictMode runs effects twice in
// development). Each caller still gets its own copy of the result.
const readMeInFlight = new Map();
const copyOf = (value) => {
  try { return typeof structuredClone === "function" ? structuredClone(value) : JSON.parse(JSON.stringify(value)); } catch (_) { return value; }
};
export const readMe = (token) => {
  const key = String(token || "");
  if (!readMeInFlight.has(key)) {
    readMeInFlight.set(key, fetchReadMe(token).finally(() => readMeInFlight.delete(key)));
  }
  return readMeInFlight.get(key).then(copyOf);
};

const fetchReadMe = async (token) => {
    //   if (!token) return;
    // le decryptage se fait dans le front diretement dans la page 
     try{
   const response = await  fetch(`${elakay_API}/readMe`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP -- the status tells the
      // caller whether the session itself was refused (401 token, 403
      // suspension) or the server was only unreachable/failing (5xx).
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        status: response.status,
        errorCode: errorData.errorCode || errorData.code || null,
        error: errorData.error || "Erreur d'identification"
      };
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      status: 0,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


// export const readMe = async (token) => {
//   try {
//     const response = await fetch(`${elakay_API}/readMe`, {
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`
//       }
//     });

//     if (!response.ok) throw new Error("Erreur serveur lors du fetch /readMe");

//     const jsonData = await response.json();

//     // ✅ Crypter la réponse
//     const encrypted = await encryptElakayData(jsonData);

//     return encrypted; // ➤ Base64 crypté que tu peux stocker, transférer, etc.
//   } catch (err) {
//     console.error("Erreur readMe:", err);
    //  return {
    //   success: false,
    //   error: err.message || "Une erreur inconnue est survenue"
    // };
//   }
// };

export const CheckEmail = async (user) => {
    try {
        const response = await fetchWithAuthTimeout(`${elakay_API}/user/CheckEmail`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(user)
        })
        if (!response.ok) {
            throw await authResponseError(response, "user/CheckEmail");
        }
        return await response.json();
    } catch (err) {
        // Used to resolve undefined on a network failure (the page then
        // crashed reading data.error).
        return authFailureResult(err, "user/CheckEmail");
    }
};

export const ChangePassword = async (token, user) => {
      try{
        const response = await  fetchWithAuthTimeout(`${elakay_API}/user/ChangePassword`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
             Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(user)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      throw await authResponseError(response, "user/ChangePassword");
    }


    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    return authFailureResult(err, "user/ChangePassword");
  }
};

export const getUserViewed = async (Viewed = []) => {
  // Vérification solide : si Viewed est null, undefined ou non-array, ou vide
  if (!Array.isArray(Viewed) || Viewed?.length === 0) {
    return {
      success: false,
      data: [],
      error: __elakayText("t004", "No recently viewed product")
    };
  }
     try{
      
    const ids = Viewed?.map(item => item._id); // ⚠️ Ne sera exécuté que si Viewed est un array valide
         
   const location = new URLSearchParams(Object.entries(locationQueryParams(undefined)).map(([k, v]) => [k, String(v)])).toString();
   const token = isAuthenticated()?.token;
   const response = await  fetch(`${elakay_API}/user/getviewed${location ? `?${location}` : ""}`, {
        // method: "GET",
         method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(typeof token === "string" && token.split(".").length === 3 ? { Authorization: `Bearer ${token}` } : {})
        },
  body: JSON.stringify({ ids })
    })
  // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};
// -----------------cart user -----------------------

export const addItem = async (token, item) => {
    try{
   // The Target Location the consumer shops for (e.g. a relative in another
   // city) is the destination the server checks Strict Location against;
   // without one the server uses the default address. The order is checked
   // again against its real shipping address.
   const target = locationQueryParams(undefined);
   const response = await  fetch(`${elakay_API}/cart/addCart`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(Object.keys(target).length && item && typeof item === "object" && !item.buyerLocation ? { ...item, buyerLocation: target } : item)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      // Keeps the server's refusal code (LOCAL_SELLING_INELIGIBLE,
      // PRODUCT_NOT_PURCHASABLE...) so the card can say why.
      const error = new Error(errorData.error || "Erreur d'identification");
      error.code = errorData.code;
      throw error;
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue",
      code: err.code || null
    };
  }

};

export const getCart = async (token) => {
      if (!token) return;
    try {
 const response = await fetch(`${elakay_API}/cart/getCart`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
        const donneesClaires = await decryptData(encryptedData);
    
        return donneesClaires;
} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const updateItem = async (token, item) => {
  try{
   const response = await fetch(`${elakay_API}/cart/updateCart`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(item)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

};

export const removeItem = (token, item) => {

    return fetch(`${elakay_API}/cart/deleteCart`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(item)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
        });
};

export const emptyCart = token => {

    return fetch(`${elakay_API}/cart/emptyCart`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
        });
};

// user address 
export const AddAddress = async (token, address) => {
     try{
   const response = await  fetch(`${elakay_API}/user/addAddress`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(address)
    })

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);
    // A new address can become the destination (Location Context).
    notifyLocationInputsChanged();

    return donneesClaires;

  } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const editAddressUser = (token, id, address) => {

    return fetch(`${elakay_API}/user/editAddressUser/${id}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(address)
    })
        .then(response => {
            notifyLocationInputsChanged();
            return response.json();
        })
        .catch(err => {
        });
};

export const getAddressUserById = async (token, id) => {

     try{
   const response = await  fetch(`${elakay_API}/user/getAddressUserById/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};



export const getAddressUserIfTrue = async (token) => {

      try{
   const response = await fetch(`${elakay_API}/user/getAddressUserIfTrue`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const getBillAdressUserIfTrue = async (token) => {

     try{
   const response = await  fetch(`${elakay_API}/user/getBillAdressUserIfTrue`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const getAddressById = async (token, id) => {
        
    try{
    const response = await  fetch(`${elakay_API}/user/getAddressById/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

      const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const checkUserAddress = (token, id) => {
    return fetch(`${elakay_API}/user/CheckAddresssDefault/${id}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            notifyLocationInputsChanged();
            return response.json();
        })
        .catch(err => {
        });
};

export const deleteUserAddress = (token, id) => {
    return fetch(`${elakay_API}/user/deleteAddress/${id}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            notifyLocationInputsChanged();
            return response.json();
        })
        .catch(error => {});

}

// user telephonee 
export const AddTelephone = async (token, telephone) => {
      try{
   const response = await  fetch(`${elakay_API}/user/telephone`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(telephone)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const deleteUserTelephoneAss = (token, id) => {
    return fetch(`${elakay_API}/user/deletePhoneUserAss/${id}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
           AuthorizationUserAdding: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(error => {});

}

export const deleteUserTelephone = (token, id) => {
    return fetch(`${elakay_API}/user/deletePhoneUser/${id}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
            return response.json();
        })
        .catch(error => {});

}
export const checkUserTelephone = (token, id) => {
    return fetch(`${elakay_API}/user/checkTelephoneUserDefaul/${id}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
        });
};

export const getStatusValues = (token) => {
    return fetch(`${elakay_API}/order/status-values`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {});
};

export const listOrders = async (token, skip, limit, sortBy, fil) => {
     try{
   const order = fil?.asc === 'asc' ? 'asc' : 'desc';
   // Additive: only sent for the new Custom Date range (fil.orderDate === 'custom'). Every
   // existing caller never sets fil.startDate/endDate, so this is a no-op for them.
   const customRange = fil?.orderDate === 'custom' && fil.startDate && fil.endDate
     ? `&startDate=${encodeURIComponent(fil.startDate)}&endDate=${encodeURIComponent(fil.endDate)}`
     : '';
   const response = await  fetch(`${elakay_API}/user/order/list?sortBy=${sortBy}&skip=${skip}&order=${order}&limit=${limit}&status=${fil.orderStatus}&date=${fil.orderDate}&myd=${fil.myd}${customRange}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }


      const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const OrdersViewById = async (token, oid, pid) => {
      try{
   const response = await  fetch(`${elakay_API}/user/orderViewId/${oid}/${pid}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }


 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// Réglage global du vendeur (manuel/automatique) pour le paiement des
// commandes CJ Dropshipping -- voir dropShipping/CJDropshipping/controllers/
// payment.controller.js:getPaymentSettings (GET /dropshipping/cj/payment-settings).
// Utilisé par orderShipped.js pour afficher le mode appliqué avant que le
// vendeur clique "Accepter" sur une commande contenant un produit CJ.
export const getCJPaymentMode = async (token) => {
    try {
        const response = await fetch(`${elakay_API}/dropshipping/cj/payment-settings`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || "Erreur d'identification");
        }
        return data;
    } catch (err) {
        console.error("Erreur lors du chargement du mode de paiement CJ :", err);
        return { error: err.message || "Une erreur inconnue est survenue" };
    }
};

export const OrdersBViewById = async (token, oid, pid) => {
      try{
   const response = await  fetch(`${elakay_API}/user/orderBViewId/${oid}/${pid}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

   
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const getGraphicOrder= async (token, oid) => {
      try{
   const response = await  fetch(`${elakay_API}/order/getGraphicOrder/${oid}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

   
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const updateOrder = async (token, getID, order) => {

    try{
   const response = await  fetch(`${elakay_API}/order/update/${getID.oid}/${getID.opid}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(order)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

  const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// Paiement en deux étapes : le seller accepte la commande, ce qui capture le
// PaymentIntent autorisé à la création de la commande (voir CheckoutProd.js).
// Distinct de updateOrder (tracking uniquement, ne capture plus rien depuis
// la refonte paiement en deux étapes).
export const acceptOrder = async (token, { oid, opid }) => {
  try {
    const response = await fetch(`${elakay_API}/order/${oid}/${opid}/accept`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Impossible de capturer le paiement");
    }

    const encryptedData = await response.json();
    if (response.status === 202) return encryptedData;
    return await decryptData(encryptedData);
  } catch (err) {
    console.error("Erreur lors de l'acceptation de la commande :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// Le seller refuse la commande avant capture : annule l'autorisation Stripe,
// rien n'est prélevé au client.
export const rejectOrder = async (token, { oid, opid }, { reason } = {}) => {
  try {
    const response = await fetch(`${elakay_API}/order/${oid}/${opid}/reject`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ reason: reason || "" })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Impossible de refuser la commande");
    }

    const encryptedData = await response.json();
    return await decryptData(encryptedData);
  } catch (err) {
    console.error("Erreur lors du refus de la commande :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// Statut sûr du paiement (jamais de client_secret) -- utile pour afficher le
// compte à rebours avant captureDeadline et l'état requires_action après 3DS.
export const getOrderProductPaymentStatus = async (token, { oid, opid }) => {
  try {
    const response = await fetch(`${elakay_API}/order/${oid}/${opid}/payment-status`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Impossible de charger le statut du paiement");
    }

    const encryptedData = await response.json();
    return await decryptData(encryptedData);
  } catch (err) {
    console.error("Erreur lors du chargement du statut de paiement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updateMessageOrder = async (token, oid, order, load = false) => {
  let query = load? `?load=${JSON.stringify(load)}`: 'false';

    try{
   const response = await  fetch(`${elakay_API}/updateMessageOrder/${oid}${query}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(order)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

  const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const sellerlistOrdersStatus = async (token, skip, limit, sortBy, fil) => {
      try{
    const order = fil?.asc === 'asc' ? 'asc' : 'desc';
    const response = await  fetch(`${elakay_API}/seller/order/list?sortBy=${sortBy}&skip=${skip}&order=${order}&limit=${limit}&status=${fil.orderStatus}&date=${fil.orderDate}&myd=${fil.myd}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

 } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const sellerlistOrders = async (token, status) => {
     try{
   const response = await  fetch(`${elakay_API}/seller/list/ByOrder/${status}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

   
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
}; 

export const orderViews = async (token, id, status) => {
    try{
   const response = await  fetch(`${elakay_API}/seller/orderViews/${id}/${status}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const UpdateUserRoleByAdmin = async (token, userInfo, role, myInfo, telPhone, emailExit, emailvsTel ) => {

     try{
   const response = await fetch(`${elakay_API}/user/UpdateUserRoleByAdmin`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ role, userInfo,  myInfo, telPhone, emailExit, emailvsTel})
    })
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
}; 

export const deleteUserById = async (userId, token, setError, setSuccess) => {
  try {
    const response = await fetch(`${elakay_API}/user/deleteExpiredInactiveUser/${userId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}` // 🔒 Envoie du token
      }
    });

    const data = await response.json();

    if (!response.ok) {
       setError(data.error)
      // alert(`Erreur : ${data.error}`);
    } else {
      setSuccess(data.message)
      // alert(`Succès : ${data.message}`);
    }
  } catch (error) {
    alert(__elakayText("t005", "Network or server error."));
  }
};

export const UserStepUP = async (token, role) => {
  const response = await fetch(`${elakay_API}/user/step-up`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(role)
    });
  const responseData = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      responseData.message ||
      responseData.error ||
      __elakayText("t005", "Network or server error.")
    );
  }
  if (responseData.requestScheduled) return responseData;
  return decryptData(responseData);
};

const roleChangeFetch = async (path, token, options = {}) => {
  const response = await fetch(`${elakay_API}${path}`, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {})
    }
  });
  const data = await response.json();
  if (!response.ok) throw Object.assign(new Error(data.message || data.error || "Role request failed."), { code: data.code });
  return data;
};

export const findRoleChangeAssociates = (token, location) => {
  const query = new URLSearchParams(
    Object.entries(location || {}).filter(([, value]) => value !== "" && value != null)
  );
  return roleChangeFetch(`/role-change/associates?${query.toString()}`, token);
};

export const createRoleChangeRequest = (token, payload) =>
  roleChangeFetch("/role-change/requests", token, {
    method: "POST",
    body: JSON.stringify(payload)
  });

export const getMyRoleChangeRequests = (token) =>
  roleChangeFetch("/role-change/mine", token);

// /your-step Royalty/Seller/Provider hierarchy Cancel/Restore (see the big
// comment above CancelRole/RestoreRole in server_elakay's
// elakay_controllers/user/user.js). reason is optional.
export const cancelUserRole = (token, reason) =>
  roleChangeFetch("/user/role-cancel", token, {
    method: "POST",
    body: JSON.stringify({ reason })
  });

export const restoreUserRole = (token) =>
  roleChangeFetch("/user/role-cancel/restore", token, { method: "POST" });

export const getAssignedRoleChangeRequests = (token) =>
  roleChangeFetch("/role-change/assigned", token);

export const getRoleChangeReviewers = (token) =>
  roleChangeFetch("/role-change/reviewers", token);

export const bulkAssignRoleChangeRequests = (token, payload) =>
  roleChangeFetch("/role-change/requests/bulk-assign", token, {
    method: "POST",
    body: JSON.stringify(payload)
  });

export const respondRoleChangeTransfer = (token, publicId, payload) =>
  roleChangeFetch(`/role-change/requests/${encodeURIComponent(publicId)}/transfer-response`, token, {
    method: "PATCH",
    body: JSON.stringify(payload)
  });

export const decideRoleChangeRequest = (token, publicId, payload) =>
  roleChangeFetch(`/role-change/requests/${encodeURIComponent(publicId)}/decision`, token, {
    method: "PATCH",
    body: JSON.stringify(payload)
  });

export const getMyAgentProfile = (token) =>
  roleChangeFetch("/agent-profile/me", token);

export const updateMyAgentProfile = (token, payload) =>
  roleChangeFetch("/agent-profile/me", token, {
    method: "PUT",
    body: JSON.stringify(payload)
  });

export const getCompletedAgentCategories = (token, { search = "", page = 1, limit = 40, sort = "asc" } = {}) => {
  const query = new URLSearchParams({ search, page: String(page), limit: String(limit), sort });
  return roleChangeFetch(`/agent-profile/categories?${query.toString()}`, token);
};

export const requestAgentEmailChange = (token, email) =>
  roleChangeFetch("/agent-profile/email-change", token, {
    method: "POST",
    body: JSON.stringify({ email })
  });

export const cancelAgentEmailChange = (token) =>
  roleChangeFetch("/agent-profile/email-change", token, { method: "DELETE" });

export const getPublicAgentProfile = (publicId) =>
  roleChangeFetch(`/agent-profile/public/${encodeURIComponent(publicId)}`, "");

export const UserAgree = async (token) => {

     try{
   const response = await  fetch(`${elakay_API}/user/user_agree`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// Decline side of the same modal (see UpdateUserRoleDecline server-side):
// withdraws a pending role proposal without touching the account's current
// role/agreeRole. Mirrors UserAgree's shape exactly (same encrypted
// a/b/e/token response) so clickDecline can reuse the same
// authenticate()/error handling as clickAgree.
export const UserDecline = async (token) => {

     try{
   const response = await  fetch(`${elakay_API}/user/user_decline`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const userAssUpRoleTrueRandom = (token) => {

    return fetch(`${elakay_API}/user/userAssUpRoleTrueRandom`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            AuthorizationUserAdding: `Bearer ${token}`
        }
    }).then(response => {
            return response.json();
        }).catch(err => {
    });
}; 

export const UserByMail = async (token, email, telPhone, emailvsTel, addme) => {
  try{
   const response = await  fetch(`${elakay_API}/user/UserByMail?addme=${addme}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email, telPhone, emailvsTel})
    })
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

}; 

export const getOrderPayRoll = async (token, skip, fil) => {
      try{
   const response = await fetch(`${elakay_API}/user/payout/order?sortBy=${''}&skip=${skip}`, {
         method: "POST",
        headers: {
            Accept: "application/json",
             "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
     body: JSON.stringify(fil)
    })
  // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const getElakayIncomme = async (token, skip, fil, usePaymentIntentIncome = false) => {
      try{
   const incomeEndpoint = usePaymentIntentIncome
     ? "elakayWalletIncomme/payment-intent"
     : "elakayWalletIncomme";
   const order = fil?.asc === 'asc' ? 'asc' : 'desc';
   const response = await fetch(`${elakay_API}/${incomeEndpoint}?sortBy=${''}&skip=${skip}&order=${order}&limit=${fil.limit}&status=${fil.orderStatus}&date=${fil.orderDate}&myd=${fil.myd}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
             "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
     body: JSON.stringify(fil)
    })
  // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    // Le nouveau dashboard consomme response.data.summary et
    // response.data.data. Les propriétés historiques restent au premier
    // niveau pour les écrans qui utilisent encore l'ancien contrat.
    return usePaymentIntentIncome
      ? { ...donneesClaires, data: donneesClaires }
      : donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const getOrderWalletSeller = async (token, status, payment) => {
      try{
   const response = await  fetch(`${elakay_API}/seller/orderWalletSeller?status=${status}&payment=${payment}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
  // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const getOrderWalletAdmin = async (token, status, payment) => {
      try{
   const response = await fetch(`${elakay_API}/seller/orderWalletAdmin?status=${status}&payment=${payment}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const addPubCategories = (token, categoryID) => {

    return fetch(`${elakay_API}/user/addPubCategories/${categoryID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
       
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {});
};

export const addFollowUserShop = async (token, userID, shopId = null, following) => {
  try{
   const response = await  fetch(`${elakay_API}/user/addFollowUserShop/${userID}`, {
        method: "PUT",
        body: JSON.stringify({ shopId, following }),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
       
    })
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw Object.assign(new Error(errorData.error || "Erreur d'identification"), { code: errorData.code });
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      code: err.code,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// export const Add_ImgPub = (token, w, h, n, photo, catID, info) => {
//     const body = new FormData()
//     body.append('photo', photo)
//     return fetch(`${elakay_API}/addUserImgPud?w=${w}&h=${h}&n=${n}&ci=${catID}`, {
//         method: "POST",
//         headers: {
//             Accept: "application/json",
//             //'content-type': 'multipart/form-data',
//             Authorization: `Bearer ${token}`
//         },
       
//         body: body
//     })
//         .then(response => {
//             return response.json();
//         })
//         .catch(err => {
//         });
// }

export const Add_ImgPub_ = (token, photos, catID) => {
  const body = new FormData();

  body.append("catID", catID);

  // Ajouter chaque photo dans le FormData
  photos.forEach((p, index) => {
    body.append(`photos`, p.file);        // les fichiers
    body.append(`w_${index}`, p.w);       // width
    body.append(`h_${index}`, p.h);       // height
    body.append(`n_${index}`, p.n);       // refIndex
  });
  return fetch(`${elakay_API}/addUserImgPud`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    },
    body
  })
    .then(res => res.json())
    .catch(err => ({
      success: false,
      errors: [
        { code: "NETWORK_ERROR", message: err.message }
      ]
    }));
};

// Shop banners / avatar. Each photo is checked and, when heavy, compressed
// before sending (the server resizes them to fixed sizes anyway); a proxy or
// server refusal comes back as { success:false, error, errors } instead of a
// JSON parse error on an HTML page.
export const Add_ImgPub = async (token, photos, catID) => {
  try {
    const prepared = await Promise.all(photos.map((p) => prepareUpload("shopImage", p.file)));
    const body = new FormData();

    body.append("catID", catID);

    // Ajouter chaque photo dans le FormData
    photos.forEach((p, index) => {
      body.append("photos", prepared[index]);           // les fichiers
      body.append(`w_${index}`, p.naturalW);            // natural width
      body.append(`h_${index}`, p.naturalH);            // natural height
      body.append(`n_${index}`, p.n);                   // refIndex
      body.append(`deviseSize_${index}`, p.deviseSize); // 'd' ou 'm'
    });

    return await withUploadRetry(async () => readUploadResponse(await fetch(`${elakay_API}/addUserImgPud`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      },
      body
    })));
  } catch (err) {
    return err.data || {
      success: false,
      error: err.message,
      errors: [
        { code: err.code || "UPLOAD_FAILED", message: err.message }
      ]
    };
  }
};


export const deleteImgPub = (token, n, urlImg) => {
   
    return fetch(`${elakay_API}/deleteImgPub?n=${n}&ui=${urlImg}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
            return response.json();
        })
        .catch(err => {
        });
}

export const userPub = (id, shopId = null) => {

    return fetch(`${elakay_API}/user_pub/${id}${shopId ? `?shop=${encodeURIComponent(shopId)}` : ""}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
        });
};

export const getAddressCountries = (code, zipcode, metadataOnly = false) => {

    return fetch(`${elakay_API}/user/countries?code=${code}&zipcode=${zipcode}${metadataOnly ? '&meta=1' : ''}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
        });
};

// Country -> State / Province -> City -> ZIP cascade from the same
// geographic data as getAddressCountries (My Profile -> Add Address).
// level: "states" | "cities" | "zipcodes". Resolves { available, items } --
// available:false = no geographic data for this country (free text).
// level "meta" -> { available, zipLengths, hasStates }; level "postal" with
// zipcode -> { available, matches: [{ zipcode, city, state, stateCode,
// latitude, longitude }], partial } (every place of that code).
export const getAddressGeoLevel = (code, level, { state = "", city = "", zipcode = "" } = {}, signal) => {
    const params = new URLSearchParams({ code: String(code || "").toLowerCase(), level });
    if (state) params.set("state", state);
    if (city) params.set("city", city);
    if (zipcode) params.set("zipcode", zipcode);
    return fetch(`${elakay_API}/user/countries?${params.toString()}`, {
        method: "GET",
        headers: { Accept: "application/json" },
        signal,
    })
        .then((response) => response.json())
        .catch((err) => (err?.name === "AbortError" ? { aborted: true } : { error: "Network error" }));
};

export const creatUserPUBToken = (pubToken, next) => {
    if (typeof window !== "undefined") {
        localStorage.setItem("UserPUBToken", JSON.stringify({pubToken}));
        next();
    }
};

export const getUserPUBToken = (next) => {
    if (typeof window === "undefined") {
        return false;
    }

    return readJsonStorage("UserPUBToken") || false;
};

export const deleteUserPubById = async (token, pubId) => {
  try {
    const response = await fetch(`${elakay_API}/user/deleteTokenPUB/${pubId}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    return await response.json();
  } catch (error) {
    console.error("deleteUserPubById error:", error);
    return { error: __elakayText("t006", "Delete request failed") };
  }
};

export const addUpdateGraphicPromo = (
  token,
  promoId,
  type,
  data,
  {
    itemId = "",
    previewImage = null
  } = {}
) => {
  const formData = new FormData();
  formData.append("type", type);
  formData.append("data", JSON.stringify(data));

  if (itemId) {
    formData.append("itemId", itemId);
  }

  if (previewImage) {
    formData.append("previewImage", previewImage);
  }

  return fetch(`${elakay_API}/graphic-promo/add-update/${promoId}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: formData
  })
    .then(res => res.json())
    .catch(err => {});
};


export const deleteGraphicPromo = (token, type, itemId) => {
  return fetch(`${elakay_API}/graphic-promo/delete`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      type,
      itemId
    })
  })
    .then(res => res.json())
    .catch(err => {});
};


export const getGraphicPromo = (token) => {
  return fetch(`${elakay_API}/graphic-promo`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .catch(err => {});
};

export const getAllGraphicPromo = (token) => {
  return fetch(`${elakay_API}/graphic-promo`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .catch(err => {});
};

export const creatTokenPUB = (
  token,
  title,
  date,
  user_id,
  prod_id,
  add_seller = false,
  add_provider = false,
  type = "PROMO",
  promotionType = "simple",
  limits = {}
) => {
  return fetch(
    `${elakay_API}/user/creatTokenPUB?data=${date}&user_id=${user_id || ""}&prod_id=${prod_id || ""}&add_seller=${add_seller}&add_provider=${add_provider}&type=${type}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ title, promotionType, ...limits }),
    }
  )
    .then((response) => response.json())
    .catch((err) => {});
};

// Verifies a Seller/Provider/Simple Promotion Token ahead of /user-step?t=,
// resolving its bound Agent server-side -- see creatUserPubToken/Pub.
export const verifyPromoToken = (token, promoT, role = null) => {
  return fetch(
    `${elakay_API}/user/promoToken/verify?t=${encodeURIComponent(promoT)}${role ? `&role=${encodeURIComponent(role)}` : ""}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => response.json())
    .catch((err) => ({ success: false, error: err?.message }));
};

export const AllMyUserReF = async (token, getFilterOurTeam) => {
      try{
   const params = new URLSearchParams({
      myUs: getFilterOurTeam.myUser, rn: getFilterOurTeam.roleName,
      asc: getFilterOurTeam.asc, limit: getFilterOurTeam.limit,
      skip: getFilterOurTeam.skip, grByR: getFilterOurTeam.grpByrole,
      UsId: getFilterOurTeam.userID, allUs: getFilterOurTeam.allUser,
      sortBy: getFilterOurTeam.sortBy, search: getFilterOurTeam.search,
      agr: getFilterOurTeam.agr,
      pointsMode: getFilterOurTeam.pointsMode || '',
      minPoints: getFilterOurTeam.minPoints ?? '',
      maxPoints: getFilterOurTeam.maxPoints ?? '',
      suspensionStatus: getFilterOurTeam.suspensionStatus || '',
      scopeMode: getFilterOurTeam.scopeMode || 'team'
   });
   const response = await  fetch(`${elakay_API}/user/AllMyUserReF?${params.toString()}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
  
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

        const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
     }
};

export const searchViewAllUsersCandidate = (token, query) =>
  fetch(`${elakay_API}/user/view-all-access/search?q=${encodeURIComponent(query)}`, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` }
  }).then(async (response) => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Unable to search user.');
    return data;
  });

export const listViewAllUsersDelegates = (token) =>
  fetch(`${elakay_API}/user/view-all-access`, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` }
  }).then((response) => response.json());

export const setViewAllUsersAccess = (token, userId, enabled) =>
  fetch(`${elakay_API}/user/view-all-access/${userId}`, {
    method: 'PATCH',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ enabled })
  }).then((response) => response.json());

// Recoit un tableau d'IDs (ex: userActiveRole.Admintean) et renvoie les
// infos publiques de chaque utilisateur correspondant — utilise par le
// modal "View Hierarchy" (cardUser.jsx).
export const getUsersByIds = async (token, ids) => {
  try {
    const response = await fetch(`${elakay_API}/user/getUsersByIds`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ ids })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur de chargement");
    }

    const encryptedData = await response.json();
    return await decryptData(encryptedData);
  } catch (err) {
    console.error("Erreur lors du chargement de la hierarchie :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// Fetches the userAddingRoleByToken activation token for one specific user
// (never the connection JWT), used to build a /user_Shoosing/:token link from
// Community Management / View Your Users. Authorized viewers only — see
// server_elakay getUserAddingRoleToken(). Response is small/non-encrypted,
// matching other narrow read endpoints like getUserAbout.
//
// ativated/startDate/experyDate are forwarded as-is (never sensitive -- see
// the server's own comment) so CardUser's activation modal can render its
// status badge, Time remaining countdown and Activity dates without a
// second round-trip -- dropping them here (as this used to) silently left
// all three blank in the UI even though the server was already sending them.
export const getUserAddingRoleToken = async (token, userID) => {
  try {
    const response = await fetch(`${elakay_API}/user/getUserAddingRoleToken/${userID}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    const data = await response.json();
    if (!response.ok) {
      return { success: false, token: null, error: data.error || "Erreur de chargement" };
    }
    return {
      success: true,
      token: data.token || null,
      ativated: data.ativated ?? null,
      startDate: data.startDate || null,
      experyDate: data.experyDate || null
    };
  } catch (err) {
    console.error("Erreur lors du chargement du token :", err);
    return { success: false, token: null, error: err.message || "Une erreur inconnue est survenue" };
  }
};


// Local Selling / geo-targeting -- one shared endpoint used identically by
// both User Settings and the "Target Location" shortcut on /myshop's header
// (mission 2.2: same component, same state, same endpoint, same saved data).
export const getLocalSelling = async (token) => {
  try {
    const response = await fetch(`${elakay_API}/user/localSelling`, {
      method: "GET",
      headers: { Accept: "application/json", Authorization: `Bearer ${token}` }
    });
    const data = await response.json();
    if (!response.ok) return { success: false, error: data.error || "Erreur de chargement" };
    return { success: true, localSelling: data.localSelling };
  } catch (err) {
    return { success: false, error: err.message || "Une erreur inconnue est survenue" };
  }
};

export const saveLocalSelling = async (token, payload) => {
  try {
    const response = await fetch(`${elakay_API}/user/localSelling`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok) return { success: false, error: data.error || "Erreur d'enregistrement" };
    return { success: true, localSelling: data.localSelling };
  } catch (err) {
    return { success: false, error: err.message || "Une erreur inconnue est survenue" };
  }
};

export const geocodeLocalSellingAddress = async (token, query) => {
  try {
    const response = await fetch(`${elakay_API}/user/localSelling/geocode`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ query })
    });
    const data = await response.json();
    if (!response.ok) return { success: false, error: data.error || "Aucun resultat trouve" };
    return { success: true, ...data };
  } catch (err) {
    return { success: false, error: err.message || "Une erreur inconnue est survenue" };
  }
};

const SETTINGS_KEY = "elakaySettings";

/**
 * Sauvegarde les paramètres dans localStorage.
 * @param {Object} settings - Objet contenant les réglages à sauvegarder.
 */
export function saveSettings(settings) {
  try {
    const serialized = JSON.stringify(settings);
    localStorage.setItem(SETTINGS_KEY, serialized);
  } catch (error) {
    console.error("Erreur lors de la sauvegarde des settings :", error);
  }
}

/**
 * Charge les paramètres depuis localStorage.
 * Retourne un objet avec SPT = true par défaut.
 * @returns {Object}
 */
export function loadSettings() {
  try {
    const serialized = localStorage.getItem(SETTINGS_KEY);

    // ✅ Valeurs par défaut
    const defaults = {
      theme: "light",
      SPT: true, // 🔥 ajouté ici
    };

    if (!serialized) {
      // Si aucun réglage sauvegardé, retourne les valeurs par défaut
      return defaults;
    }

    // Fusionne les réglages sauvegardés avec les valeurs par défaut
    const parsed = JSON.parse(serialized);
    return { ...defaults, ...parsed };
  } catch (error) {
    console.error("Erreur lors du chargement des settings :", error);
    return { SPT: true }; // au minimum, retourne SPT activé
  }
}

// Switch Role / View As Role (Phase 1) -- kept in its own key rather than
// piggybacked on SETTINGS_KEY above: this is a security-relevant,
// per-account value the backend re-validates on every app load (see
// Routes.js's readUser()), not a generic UI preference like theme/SPT, so it
// deserves to be trivially inspectable/clearable on its own. Never trust
// this value by itself -- it's only ever used as a hint to re-request the
// same view after a refresh; the backend independently recomputes whether
// it's still allowed (spec: "never trust localStorage alone").
const SELECTED_ROLE_KEY = "elakaySelectedRole";

export function persistSelectedRole(roleName) {
  try {
    if (roleName) localStorage.setItem(SELECTED_ROLE_KEY, roleName);
    else localStorage.removeItem(SELECTED_ROLE_KEY);
  } catch (error) {
    console.error("Erreur lors de la sauvegarde du rôle sélectionné :", error);
  }
}

export function getPersistedSelectedRole() {
  try {
    return localStorage.getItem(SELECTED_ROLE_KEY) || null;
  } catch (error) {
    return null;
  }
}

export function clearPersistedSelectedRole() {
  persistSelectedRole(null);
}


// utils/historySearch.js

export function getFirstIds(data, n= 5) {
  if (!Array.isArray(data) || typeof n !== "number" || n <= 0) return [];
  return data.slice(0, n).map((item) => item?._id).filter(Boolean);
}

export function readHistorySearchLS(key = "historySearch") {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function writeHistorySearchLS(ids, key = "historySearch") {
  try {
    localStorage.setItem(key, JSON.stringify(Array.isArray(ids) ? ids : []));
    return true;
  } catch {
    return false;
  }
}

export function clearHistorySearchLS(key = "historySearch") {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

// fusion unique (garde l’ordre: new d’abord, puis anciens)
export function mergeUniqueIds(newIds = [], oldIds = [], limit = 10) {
  const seen = new Set();
  const merged = [];
  for (const id of [...newIds, ...oldIds]) {
    if (!id || seen.has(id)) continue;
    seen.add(id);
    merged.push(id);
    if (merged.length >= limit) break;
  }
  return merged;
}

export const creatHistorySearch = (token, historyData) => {
  return fetch(`${elakay_API}/user/historySearch`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(historyData),
  })
    .then((res) => res.json())
    .catch((err) => ({
      success: false,
      error: err?.message || "Une erreur inconnue est survenue",
    }));
};
